import { VibratoClient } from "@/lib/vibrato-api"
import { Modal, ModalBody, ModalHeader } from "flowbite-react"
import React, { useContext } from "react"
import { VibratoClientContext } from "./contexts"

export default function PastDueModal({
  showModal,
  setShowModal
}: {
  showModal: boolean
  setShowModal: (show: boolean) => void
}): React.JSX.Element {
  const vibratoClient: VibratoClient = useContext(VibratoClientContext)

  const redirectToStripePortal = () => {
    vibratoClient
      .getUserStripeDetails()
      .then((details) => {
        window.location.href = details.stripe_portal_url
      })
      .catch((err) => {
        console.error("Error fetching stripe portal url", err)
      })
  }

  return (
    <>
      <Modal show={showModal} onClose={() => setShowModal(false)} className="pt-safe">
        <ModalHeader className="border-b border-gray-200">🚨 Vibrato Plus Account Past Due!</ModalHeader>
        <ModalBody>
          <div className="flex flex-col gap-2">
            <p className="text-lg font-semibold mb-2">⏰ Your Vibrato Plus account is past due!</p>
            <p>
              We&apos;ve noticed your account payment is past due. To avoid interruption of your{" "}
              <span className="font-bold">Vibrato Plus</span> service, please update your payment method within the next
              few days 🗓️.
            </p>
            <div className="mt-4 text-left">
              <strong>Keep Enjoying These Benefits:</strong>
              <ul className="list-disc list-inside">
                <li>📞 Unlimited Call Minutes</li>
                <li>🎤 Voice Cloning Features</li>
                <li>🛎️ Priority Support</li>
                <li>🔧 Exclusive Updates and Tools</li>
              </ul>
            </div>
            <div className="mt-4">
              <p>
                Don&apos;t miss out on uninterrupted service. Update your payment method now to continue enjoying all
                the perks of <span className="font-bold">Vibrato Plus</span> 💎.
              </p>
            </div>
            <div className="mt-4 flex justify-center">
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
                onClick={redirectToStripePortal}
              >
                Update Payment Method
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}
